var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.042 13.208H9.32559L8.03846 8.15312C7.97737 7.9206 7.84765 7.71503 7.65684 7.61814C7.18065 7.37467 6.65593 7.1809 6.0835 7.08317V6.88855H8.84857C9.23018 6.88855 9.5164 7.1809 9.5641 7.52042L10.2319 11.1667L11.9475 6.88855H13.6162L11.042 13.208ZM14.5707 13.208H12.9497L14.2845 6.88855H15.9055L14.5707 13.208ZM18.0021 8.6385C18.0498 8.29813 18.336 8.10352 18.6699 8.10352C19.1946 8.05466 19.7662 8.15239 20.2432 8.39502L20.5294 7.03441C20.0524 6.8398 19.5277 6.74207 19.0515 6.74207C17.4782 6.74207 16.3333 7.61741 16.3333 8.83227C16.3333 9.75647 17.1442 10.2418 17.7167 10.5341C18.336 10.8256 18.5745 11.0202 18.5268 11.3117C18.5268 11.749 18.0498 11.9436 17.5736 11.9436C17.0011 11.9436 16.4287 11.7978 15.9048 11.5544L15.6186 12.9158C16.191 13.1584 16.8103 13.2562 17.3828 13.2562C19.1469 13.3042 20.2432 12.4297 20.2432 11.1171C20.2432 9.46413 18.0021 9.36724 18.0021 8.6385ZM25.9167 13.208L24.6296 6.88855H23.247C22.9608 6.88855 22.6746 7.08317 22.5792 7.37467L20.1958 13.208H21.8645L22.1976 12.2847H24.248L24.4388 13.208H25.9167ZM23.486 8.58973L23.9622 10.9715H22.6274L23.486 8.58973Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.aedaa1d4e70006c3c9e223259c878aff.svg";
export { ForwardRef as ReactComponent };